const lines = document.querySelectorAll('.layout__grid-lines span');

const totalLines = lines.length * 2;
const allStates = [];

for (let i = 0; i < totalLines; i++) {
    allStates.push({
        progress: Math.random() * 500,
        maxLen: 200 + Math.random() * 1000,
        growthSpeed: 0.5 + Math.random() * 1.8,
        shrinkSpeed: 0.03 + Math.random() * 0.12,
        inertia: 0.5 + Math.random(),
        wobble: 0.2 + Math.random() * 0.8,
        phase: Math.random() * Math.PI * 2,
        shrinkResistance: 0.3 + Math.random() * 0.7
    });
}

let lastScrollY = window.scrollY;
let velocity = 0;
let smoothVelocity = 0;
let time = 0;

window.addEventListener('scroll', () => {
    const y = window.scrollY;
    velocity = y - lastScrollY;
    lastScrollY = y;
});

function animate() {
    time += 0.03;

    smoothVelocity = smoothVelocity * 0.92 + velocity * 0.08;

    let processedVelocity = smoothVelocity;
    if (processedVelocity < 0) {
        processedVelocity = processedVelocity * 0.25;
    }

    let lineIndex = 0;

    lines.forEach((el, spanIndex) => {
        const leftState = allStates[lineIndex++];
        const rightState = allStates[lineIndex++];

        const leftWave = Math.sin(time * leftState.wobble + leftState.phase) * 0.3;
        const rightWave = Math.sin(time * rightState.wobble + rightState.phase) * 0.3;

        let leftDelta = processedVelocity * leftState.growthSpeed;
        if (leftDelta > 0) {
            leftDelta += leftWave;
        } else {
            leftDelta = leftDelta * leftState.shrinkSpeed * leftState.shrinkResistance;
            leftDelta += leftWave * 0.1;
        }
        leftState.progress += leftDelta;
        leftState.progress = Math.max(0, Math.min(leftState.maxLen, leftState.progress));

        let rightDelta = processedVelocity * rightState.growthSpeed;
        if (rightDelta > 0) {
            rightDelta += rightWave;
        } else {
            rightDelta = rightDelta * rightState.shrinkSpeed * rightState.shrinkResistance;
            rightDelta += rightWave * 0.1;
        }
        rightState.progress += rightDelta;
        rightState.progress = Math.max(0, Math.min(rightState.maxLen, rightState.progress));

        el.style.setProperty('--line-h-left', `${leftState.progress}px`);
        el.style.setProperty('--line-h-right', `${rightState.progress}px`);
    });

    velocity *= 0.95;

    requestAnimationFrame(animate);
}

animate();